import React from 'react';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { ImpactBoxes } from './impact_boxes.wjs.jsx';

export class TwelveMonthImpactReportContainer extends React.Component {
  getStateFromStore = () => {
    const userPercentile =
      Aedu.ReduxStore.getState().AnalyticsDashboard.ImpactAggregations
        .aggregations.collections.percentiles &&
      Aedu.ReduxStore.getState().AnalyticsDashboard.ImpactAggregations
        .aggregations.collections.percentiles.global[0];

    return {
      displayedDates:
        Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
      impactAggregations:
        Aedu.ReduxStore.getState().AnalyticsDashboard.ImpactAggregations,
      userPercentile: {
        model: userPercentile,
      },
    };
  };

  dispatchFetches = () => {
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.ImpactAggregations.fetch(),
    );
  };

  componentWillMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    this.dispatchFetches();
  }

  // No componentDidUpdate refetch on purpose: the ImpactAggregations slice has no
  // SET_DISPLAYED_DATES reset, so it's fetched once on mount and never needs
  // re-dispatching. Re-dispatching on every re-render (this component setState's
  // on every store change) previously turned an erroring twelve_month_impact
  // endpoint — whose slice doesn't latch `exhausted` on failure — into an
  // unbounded ~1 req/sec refetch loop that tripped Cloudflare rate limiting.

  componentWillUnmount() {
    this.unsubscribe();
  }

  showPagesReadDisclaimer = () => {
    // This makes the assumption that this page is being viewed less than 12
    // months after we started recording pages read
    return true;
  };

  state = this.getStateFromStore();

  render() {
    if (this.state.impactAggregations.meta.fetching) {
      return (
        <div className="u-taCenter u-pv4x">
          <i className="fa fa-spin fa-spinner u-fs36"></i>
        </div>
      );
    }

    // A failed fetch leaves `aggregations.collections` at its `{}` initialState;
    // rendering ImpactBoxes would then dereference absent aggregations (e.g.
    // `collections.percentiles.research_interest` below) and throw in render(),
    // unmounting the whole analytics tree. Show the standard error state instead.
    if (
      this.state.impactAggregations.meta.errorFetching ||
      !this.state.impactAggregations.aggregations.collections.percentiles
    ) {
      return (
        <NoDataTab
          title="There was an error loading your analytics."
          details="This may have been caused by a connection issue - try reloading the page."
          loggedOutTitle={
            'There was an error loading ' +
            Aedu.User.viewed.display_name +
            "'s analytics."
          }
          noUploadButton={true}
        />
      );
    }

    return (
      <ImpactBoxes
        displayedDates={this.state.displayedDates}
        userPercentile={this.state.userPercentile}
        visitorCount={
          this.state.impactAggregations.aggregations.counts.visitor_count
        }
        visitorCountFetching={this.state.impactAggregations.meta.fetching}
        downloadCount={
          this.state.impactAggregations.aggregations.counts.download_count
        }
        downloadCountFetching={this.state.impactAggregations.meta.fetching}
        hitCount={this.state.impactAggregations.aggregations.counts.hit_count}
        hitCountFetching={this.state.impactAggregations.meta.fetching}
        topCountries={
          this.state.impactAggregations.aggregations.collections.countries
        }
        topCountriesFetching={this.state.impactAggregations.meta.fetching}
        topCities={
          this.state.impactAggregations.aggregations.collections.cities
        }
        topCitiesFetching={this.state.impactAggregations.meta.fetching}
        topUniversities={
          this.state.impactAggregations.aggregations.collections.universities
        }
        topUniversitiesFetching={this.state.impactAggregations.meta.fetching}
        topPositions={
          this.state.impactAggregations.aggregations.collections.positions
        }
        topPositionsFetching={this.state.impactAggregations.meta.fetching}
        topDocs={this.state.impactAggregations.aggregations.collections.docs}
        topDocsFetching={this.state.impactAggregations.meta.fetching}
        // This is for single work impact only
        furthestPages={
          this.state.impactAggregations.aggregations.collections.furthest_pages
        }
        furthestPagesFetching={this.state.impactAggregations.meta.fetching}
        showPagesReadDisclaimer={this.showPagesReadDisclaimer()}
        topTrafficSources={
          this.state.impactAggregations.aggregations.collections.traffic_sources
        }
        topTrafficSourcesFetching={this.state.impactAggregations.meta.fetching}
        topSearches={
          this.state.impactAggregations.aggregations.collections.searches
        }
        topSearchesFetching={this.state.impactAggregations.meta.fetching}
        topResearchInterestPercentiles={
          this.state.impactAggregations.aggregations.collections.percentiles
            .research_interest
        }
        topResearchInterestPercentilesFetching={
          this.state.impactAggregations.meta.fetching
        }
        readerResearchInterestCount={
          this.state.impactAggregations.aggregations.counts
            .reader_research_interest_count
        }
        topReaderResearchInterests={
          this.state.impactAggregations.aggregations.collections
            .reader_research_interests
        }
        topReaderResearchInterestsFetching={
          this.state.impactAggregations.meta.fetching
        }
        twelveMonth={true}
      />
    );
  }
}
